import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { PayPeriod } from 'projects/app-misc/src/app/modules/punch-time-widget/data/pay-period';
import { TimeCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import { TimeCardService } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import { TimeCardsQuery } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-cards.query';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import moment from 'moment';
import businessMoment from 'moment-business';

import { TimesheetEditDialogComponent } from '../../../timesheet-edit-dialog/timesheet-edit-dialog.component';
import { ReportCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/report-card';
import { WeekCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/week-card';
import { RecordCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/record-card';
import { trackEntityById, takeUntilDestroyed } from 'projects/core/src/public-api';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import { MapMarkerDialogComponent } from './map-marker-dialog/map-marker-dialog.component';
import { DayCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/day-card';
import { User } from 'projects/core/src/lib/login/data/user';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject } from 'rxjs';

interface DateObject {
  date: Date;
}

@Component({
  selector: 'app-timesheets-report-dialog',
  templateUrl: './timesheets-report-dialog.component.html',
  styleUrls: ['./timesheets-report-dialog.component.scss']
})
@RxJSUnsubscribe
export class TimesheetsReportDialogComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  currentUser: User;

  payPeriod: PayPeriod;

  reportCard: ReportCard;

  sheetLoading = true;

  timeCardToSave: TimeCard;

  trackEntityById = trackEntityById;

  dateString: string;


  days: DateObject[] = [];
  selectedDay: DateObject;
  hoursToFill: number;

  isMobile: boolean


  constructor(
    protected timeCardService: TimeCardService,
    protected timeCardsQuery: TimeCardsQuery,
    private appStateQuery: AppStateQuery,
    private timeCardsService: TimeCardService,
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: {
      payPeriod: PayPeriod,
      isMobile: boolean
    }
  ) {
    this.payPeriod = data.payPeriod;
    this.isMobile = this.data.isMobile;
    this.dateString = `${moment(this.payPeriod.start).format('MMM D')} - ${moment(this.payPeriod.finish).format('MMM D')}`
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => {
      this.currentUser = currentUser;
    });

    this.countDays();

    this.getCards();
  }

  countDays() {
    let currentDate = moment(this.payPeriod.start);
    const stopDate = moment(this.payPeriod.finish);
    while(currentDate <= stopDate) {
      this.days.push({
        date: moment(currentDate).toDate()
      })

      currentDate = moment(currentDate).add(1, 'days');
    }
  }

  returnZero() {
    return 0
  }

  getCards() {
    this.timeCardService.getReportCardsForUser(this.payPeriod.user.id, this.payPeriod.start, this.payPeriod.finish).pipe(takeUntil(this.getUnsubFromAllSubs())).subscribe(reportCard => {
      this.reportCard = reportCard
      this.sheetLoading = false;
    })
  }

  fillHours() {
    if(typeof this.hoursToFill !== 'undefined') {

      this.timeCardsService.fillHours(this.payPeriod.user.id, moment(this.selectedDay.date).format('YYYY-MM-DD'), moment(this.selectedDay.date).format('YYYY-MM-DD'), this.hoursToFill).subscribe(() => {
        this.getCards();
        this.hoursToFill = undefined;
      })
    }
  }

  openSheetDialog(record: RecordCard) {
    if(typeof record.projectId !== 'undefined') {
      this.timeCardToSave = {
        id: record.id,
        startTime: record.start,
        finishTime: record.finish,
        job: {
          id: record.projectId
        }
      }
    } else {
      this.timeCardToSave = {
        id: record.id,
        startTime: record.start,
        finishTime: record.finish
      }
    }

    const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
      data: {
        timeCard: this.timeCardToSave,
        buttonLabel: 'Save',
        selectedUser: this.reportCard.user,
        adminPermissions: true
      },
      disableClose: true,
      panelClass: 'time-sheet-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getCards();
    });
  }

  addSheet() {
    const dialogRef = this.dialog.open(TimesheetEditDialogComponent, {
      data: {
        buttonLabel: 'Add',
        selectedUser: this.payPeriod.user
      },
      disableClose: true,
      panelClass: 'time-sheet-edit-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getCards();
    });
  }

  getWeekIndex(week: WeekCard) {
    return this.reportCard.weeks.indexOf(week, 0) + 1;
  }

  approve() {
    this.timeCardService.togglePayPeriod(this.payPeriod.user.id, moment(this.payPeriod.start).format('YYYY-MM-DD'), moment(this.payPeriod.finish).format('YYYY-MM-DD')).subscribe(emit => {
      this.payPeriod.approved = !this.payPeriod.approved;
    })
  }

  openPdfPeriod(): void {
    // this.sendData.emit(this.currentUser)

    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: `${this.payPeriod.user.name} ${moment(this.payPeriod.start).format('MMM D')} - ${moment(this.payPeriod.finish).format('MMM D')}`,
        link: '/time_card/user/' + this.payPeriod.user.id + '/punch-time/report/' + moment(this.payPeriod.start).format('YYYY-MM-DD') + ':' + moment(this.payPeriod.finish).format('YYYY-MM-DD'),
        showSendButton: false

      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  openPunchInMapWithMarker(record: RecordCard, event) {
    const cpDialogRef = this.dialog.open(MapMarkerDialogComponent, {
      data: {
        lat: record.punchInLat,
        long: record.punchInLong,
      },
      panelClass: 'map-marker-dialog'
    });
    event.stopPropagation();
  }

  openPunchOutMapWithMarker(record: RecordCard, event) {
    const cpDialogRef = this.dialog.open(MapMarkerDialogComponent, {
      data: {
        lat: record.punchOutLat,
        long: record.punchOutLong,
      },
      panelClass: 'map-marker-dialog'
    });
    event.stopPropagation();
  }

  ngOnDestroy() {

  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
